import React from 'react';
import { projects } from '../mock';

const Intro = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-start">
        <div>
          <h2 className="text-[#2C5F66] text-4xl md:text-5xl font-extrabold leading-tight mb-8">
            WEB DEVELOPMENT AND INBOUND MARKETING EXPERTS
          </h2>
          <p className="text-gray-600 leading-relaxed mb-5 text-[15px]">
            Are you launching a new business website or looking to generate more inbound leads and online sales? At <strong className="text-[#2C5F66]">Website Symphony</strong>, we combine professional <a href="#" className="text-[#D9A04A] hover:underline">web design</a> with powerful A.I. services to help your business stand out and grow. We understand that every business has unique goals, which is why we create custom-designed websites enhanced with <a href="#" className="text-[#D9A04A] hover:underline">A.I. driven automation</a>, smart marketing strategies, and data insights to attract and convert visitors.
          </p>
          <p className="text-gray-600 leading-relaxed mb-8 text-[15px]">
            A vibrant, intelligently optimized website not only boosts traffic and digital exposure but also improves customer engagement and conversion rates. Your website is the foundation of your <a href="#" className="text-[#D9A04A] hover:underline">marketing</a> efforts and with <strong className="text-[#2C5F66]">Website Symphony</strong>’s A.I. powered solutions, we help turn more visitors into loyal customers. Contact us today for a quote using our <a href="#" className="text-[#D9A04A] hover:underline">Free Web Estimate</a> form!
          </p>
          <a
            href="#contact"
            className="inline-block bg-[#C68B30] hover:bg-[#B17A24] text-white font-semibold px-8 py-4 rounded-md tracking-wide transition-colors"
          >
            RECEIVE FREE ESTIMATE
          </a>
        </div>

        <div className="grid grid-cols-2 gap-5">
          {projects.map((p) => (
            <div key={p.name} className="relative group overflow-hidden rounded-md shadow-md">
              <img
                src={p.image}
                alt={p.name}
                className="w-full h-[400px] object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-4">
                <p className="text-white font-semibold text-sm">{p.name}</p>
              </div>
            </div>
          ))}
          <div className="col-span-2 flex justify-center">
            <a
              href="#portfolio"
              className="inline-block bg-[#2C5F66] hover:bg-[#244e54] text-white font-semibold px-8 py-3 rounded-md transition-colors"
            >
              View Portfolio
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Intro;
